var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',[_c('el-skeleton',{attrs:{"rows":12,"animated":"","loading":_vm.logined}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }